module.exports = __webpack_public_path__ + "images/emoji/grey_question.7015c3d4e6917b822bf7.png";